import React from 'react';

function ModalCloseBtn(props) {
    return (
        <div className="popup_close" style={{ color: '#000', position: 'absolute', top: '15px', right: '15px', cursor: 'pointer', backgroundColor: 'transparent', border: '0px', borderRadius: '0px'}} >
            Close
            <i className="fa fa-times" style={{marginLeft: '4px'}}></i>  
        </div>
    );
}

export default ModalCloseBtn;